var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.416 8.584 10 4 8.584 8.584H4l3.708 2.832L6.292 16 10 13.167 13.708 16l-1.416-4.584L16 8.584h-4.584Zm2.325.771h-2.858L10 6.497l-.883 2.858H6.258l2.313 1.767-.883 2.858L10 12.213l2.312 1.767-.883-2.858 2.313-1.767Z",
    fill: "currentColor"
  })));
};
export default SvgStar;